import { useEffect } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Ticker } from "@/components/landing/Ticker";
import { Benefits } from "@/components/landing/Benefits";
import { Partners } from "@/components/landing/Partners";
import { Packages } from "@/components/landing/Packages";
import { Gallery } from "@/components/landing/Gallery";
import { Process } from "@/components/landing/Process";
import { Payment } from "@/components/landing/Payment";
import { Roadmap } from "@/components/landing/Roadmap";
import { FAQSection } from "@/components/landing/FAQSection";
import { Reservation } from "@/components/landing/Reservation";
import { Footer } from "@/components/landing/Footer";
import { ResumeBanner } from "@/components/ResumeBanner";
import { trackPageview } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    trackPageview();
  }, []);

  return (
    <main className="bg-[#FAFAF7] text-[#0A0A0F] min-h-screen overflow-x-hidden" style={{ paddingTop: "var(--wf-banner-h, 0px)" }}>
      <ResumeBanner />
      <Navbar />
      <Hero />
      <Ticker />
      <Benefits />
      <Partners />
      <Packages />
      <Gallery />
      <Process />
      <Payment />
      <Roadmap />
      <FAQSection />
      <Reservation />
      <Footer />
    </main>
  );
}
